export default __webpack_public_path__ + "static/bg-blood--mobile-dc7fa29b7c83bc6ba30dbe3af925592c.webp";